import Vue from 'vue';
import { Validator } from 'vee-validate';
export default function () {
  this.emergencyContactValidation = function () {
    const dictonary = {
      custom: {
        emgContName: {
          required: () => "emg ContName is required"
        },
        emgContNum: {
          required: () => "emg ContNum is required"
        },
        relateType: {
          required: () => "Relate Type is required"
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmergencyContactValidation.js